export enum TicketValidationResult {
  ERROR,
  VALID,
  INVALID,
}
